import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function LoginForm() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ email: '', password: '' });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            const user = await login(form.email, form.password);
            navigate(user.role === 'teacher' ? '/teacher/dashboard' : user.role === 'admin' ? '/admin/dashboard' : '/student/dashboard');
        } catch (err) {
            setError(err.response?.data?.message || 'Login yoki parol xato');
        } finally { setLoading(false); }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-900 flex items-center justify-center px-4">
            <div className="w-full max-w-md">
                <div className="text-center mb-8">
                    <Link to="/" className="inline-block">
                        <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center text-3xl text-white font-bold mx-auto mb-4 shadow-xl shadow-blue-500/30">S</div>
                    </Link>
                    <h1 className="text-3xl font-bold text-white mb-2">Xush kelibsiz!</h1>
                    <p className="text-blue-300/70">SmartEduLab platformasiga kirish</p>
                </div>

                <div className="bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-8 shadow-2xl">
                    {error && <div className="bg-red-500/20 text-red-300 px-4 py-3 rounded-xl text-sm mb-4">{error}</div>}

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-blue-200 mb-1.5">Email</label>
                            <input type="email" value={form.email} onChange={e => setForm({...form, email: e.target.value})} className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white placeholder-blue-300/50 outline-none focus:border-blue-400 transition" placeholder="email@example.com" required />
                        </div>
                        <div>
                            <label className="block text-sm font-medium text-blue-200 mb-1.5">Parol</label>
                            <input type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} className="w-full px-4 py-3 rounded-xl bg-white/10 border border-white/20 text-white placeholder-blue-300/50 outline-none focus:border-blue-400 transition" placeholder="••••••••" required />
                        </div>
                        <button type="submit" disabled={loading} className="w-full py-3 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-xl font-bold hover:opacity-90 transition disabled:opacity-50 shadow-lg shadow-blue-500/25">
                            {loading ? 'Kirish...' : 'Kirish'}
                        </button>
                    </form>

                    <p className="text-center text-blue-300/70 text-sm mt-6">
                        Akkauntingiz yo'qmi? <Link to="/register" className="text-blue-400 font-medium hover:text-blue-300">Ro'yxatdan o'tish</Link>
                    </p>
                </div>
            </div>
        </div>
    );
}